import { styled } from '@mui/material';

export const CardContainerBox = styled('a')`
  height: 100%;
  display: block;

  &:hover {
    cursor: pointer;
  }
`;
